/** Width of the persistent sidebar drawer in pixels. */
export const DRAWER_WIDTH = 240;
